import React, { useState } from 'react'
import { useLoginMutation } from "../../Redux/Api/AuthApi";
import { useDispatch } from "react-redux";
import { credential } from "../../Redux/Slice/AuthSlice";
import {Link, useLocation, useNavigate} from 'react-router-dom';
import "./Login.css"
//import Navbar from '../../Component/Navbar';


const Login = () => { 
  
  const [Err,setErrMsg] = useState('')
  const [email,setEmail] = useState('')
  const [password,setPassword] = useState('')
  const location = useLocation();

  // Retrieve the path the user was on before login, or default to home
  const from = location.state?.from?.pathname ;
  const [login, { isError, isLoading,}] = useLoginMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleSubmit = async(e)=>{
        e.preventDefault()
    
      try {
        const response = await login({ email, password });
        console.log(response);

        // 1. Handle SUCCESS (2xx)
        if (response?.data) {
          const userData = response.data.data;
          dispatch(credential(JSON.stringify(userData)));

          if (userData.role === "admin") {
            return navigate('/panel/admin/dashboard');
          }else{
            if(!from){
              return navigate('/portal/booking')
            }
            return navigate(from,{replace:true})
          }
          
        } 
        
        // 2. Handle ERRORS (4xx, 5xx)
        const errorStatus = response?.error?.status;
        const errorData = response?.error?.data?.data; // Data sent even on failure

        if (errorStatus === 402) {
          console.log(errorStatus)
          if (errorData) dispatch(credential(JSON.stringify(errorData)));
          return navigate('/portal/booking/classes/childQuestion');
        } 

        if (errorStatus === 403) {
          console.log(errorStatus)
          if (errorData) dispatch(credential(JSON.stringify(errorData)));
          return navigate('/portal/booking/classes/renew/subscription');
        }

        // 3. Fallback for other errors (401, 500, etc.)
        setErrMsg(response?.error?.data?.message || "Login failed");

      } catch (error) {
        console.error("Unexpected crash:", error);
      }
     
      }

    return (
      <div className='kiga-login'>
      <div className='kiga-login-main'>
         <div className='kiga-login-logo'>
            <div className='kiga-login-logo-image'>
            <Link to='/'><img src='/images/logo2.png' alt='logo'/></Link>
            </div>
         </div>
         <div className='kiga-login-content'>
            <div className='kiga-login-content-title'>
              <p>Sign in to your Account</p>
            </div>
           <form onSubmit={handleSubmit} className='kiga-login-form'>
            <div className='kiga-login-label'>
              <label htmlFor='name'>Email Address</label>
            </div>
            <div className='kiga-login-input'>
              <input type='email' placeholder={`${' '} ${' example@gmail.com'} `} required onChange={(e)=>setEmail(e.target.value)}/>
            </div>
            <div className='kiga-login-label'>
              <label htmlFor='password'>Password</label>
            </div>
            <div className='kiga-login-input'>
              <input type='password' placeholder={`${' '} ${' ********'} `} required onChange={(e)=>setPassword(e.target.value)}/>
            </div>
            {
                isError ? (
                  <div className="error-msg">
                    <p>{Err}</p>
                  </div>
                ):null
            }
            <div className='kiga-login-button'>
              {
                  isLoading ? (
                    <button type="submit" disabled>
                  Loading...
                  </button>
                  ) : (
                  <button type='submit'>Login</button>
                  )
              }
            </div>
           </form>
           <div className='kiga-login-link-account'>
             <p>Don't have an account?{' '}<Link to='/register'>Sign Up</Link> </p>
           </div>
         </div>
      </div>
    </div>
  )
}



export default Login
